import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-around',
  },
  containerTopColor: theme => ({
    borderTopColor: theme.colors.horizontalLineColor,
    minWidth: '100%',
  }),
  tab: theme => ({
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 5,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.horizontalLineColor,
    height: 50,
  }),
  tabScroll: {
    flexGrow: 1,
    flexDirection: 'row',
    paddingHorizontal: 15,
  },
  activeLine: {
    position: 'absolute',
    height: 4,
    bottom: 0,
    left: 0,
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
  },
  activeTabBackgroundColorColor: theme => ({
    backgroundColor: theme.colors.activeTabColorTwo,
  }),
  activeLineScrollWidth: {
    width: 1,
  },
});
